// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import LoadingOverlay from "./features/ui/LoadingOverlay";
import HomePage, { DEFAULT_TAB_PATH } from "./pages/HomePage.jsx";
import AssignmentPage from "./pages/AssignmentPage.jsx";
import PreviewPage from "./pages/PreviewPage.jsx";
import ReviewPage from "./pages/ReviewPage.jsx";

// 알림톡으로 나간 링크(/home?session=...)를 기본 메뉴로 넘긴다.
// 세션이 쿼리스트링에 있으므로 반드시 들고 가야 한다.
const HomeRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`${DEFAULT_TAB_PATH}${search}`} replace />;
};

function App() {
  return (
    <Router>
      <LoadingOverlay>
        <Routes>
          <Route path="/home" element={<HomeRedirect />} />
          <Route path="/assignment" element={<AssignmentPage />} />
          <Route path="/preview" element={<PreviewPage />} />
          <Route path="/review" element={<ReviewPage />} />
          {/* 상단 메뉴. 위의 고정 주소가 먼저 잡히고 나머지가 여기로 온다
              (react-router 는 고정 경로를 :파라미터보다 앞에 둔다). */}
          <Route path="/:topTab" element={<HomePage />} />
        </Routes>
      </LoadingOverlay>
    </Router>
  );
}

export default App;
